
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/2fbbd7b8-2d0a-4e26-8a02-350e8083557e.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('2fbbd7b8-2d0a-4e26-8a02-350e8083557e');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      